import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import InfiniteScroll from "react-infinite-scroll-component";
import { use } from "react";
import { fetchAPI } from "@/utility/NetworkUtils";
import { Tooltip } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import ItemImageGalleryModal from "../items/components/ItemImageGalleryModal";
import { useConfirm } from 'material-ui-confirm';
import ReceivingListModal from "../items/form/ReceivingListModal";
import ReceivingListRecieveModal from "./ReceivingListRecieveModal";
import SuperFilter from "../layouts/superfilter/SuperFilter";
import {
  Button
} from "@mui/material";
import CreateNewItemSearchModal from "../items/form/CreateNewItemSearchModal";
import { getTracking, dhl, fedex, ontrac, s10, ups, usps } from 'ts-tracking-number';

import SortIcon from '@mui/icons-material/Sort';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import { isJaguar } from "../utility/UserUtils"
import Draggable from "react-draggable";
const ReceivingListTable = (props) => {
  const { user } = props;
  const confirm = useConfirm();
  const [ receivingItems, setReceivingItems ] = useState([]);
  const [ page, setPage ] = useState(0);
  const [ total_pages, setTotalPages ] = useState(1000);
  const [ events, setEvents ] = useState([]);
  const [superFilters, setSuperFilters] = useState(null);
  const [ renters, setRenters ] = useState([]);
  const [ sortBy, setSortBy ] = useState(null);
  const [ sortDirection, setSortDirection ] = useState("asc");


  useEffect(() => {
    fetchEvents();
    fetchRenters();
  },[]);

  const fetchRenters = async () => {
    fetchAPI(`/webapi/renters`, (json)=> {
      if (!json.errors) {
        setRenters(json.renters)
      } else {
        console.log({
          errors: json.errors
        })
      }
    });
  }

  const fetchEvents = async () => {
    fetchAPI(`/webapi/events`, (json)=> {
      if (!json.errors) {
        setEvents(json.events)
      } else {
        console.log({
          errors: json.errors
        })
      }
    });
  }

  useEffect(() => {
    fetchMoreData()
  }, [superFilters, sortBy, sortDirection]);

  const renderSuperFilter = () => {
    return(
      <>
        <SuperFilter
          urlLock={true}
          search={false}
          disableLabel={true}
          onChange={(filters) => {
            setReceivingItems([])
            setPage(0)
            setSuperFilters(filters);
          }}
          id={`receiving-list-superfilter`}
          lockable
          filters={getSuperFilters()}
        />
      </>
    )
  }

  getCarriers = () => {
    return [
      "UPS",
      "FedEx",
      "United States Postal Service",
      "DHL",
      "OnTrac",
    ]
  }

  const getSuperFilters = () => {
    return [
      {
        id: "renter",
        type:"multiselect",
        options: renters.map((renter) => {return {
          id: `${renter.id}`, 
          label: `${renter.name}`
        }}),
        outerClassName: "sg-super-filter-select-field-option-spacing",
        placeholder: "By Renter", 
        name: "Renter",
        to_filter: renters.length < 2
      },
      {
        id: "event",
        type:"multiselect",
        options: events.filter(x=> x.archived_at == null).sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)).map((event) => {return {
          id: event.slug, 
          label: event.name
        }}),
        outerClassName: "sg-super-filter-select-field-option-spacing",
        placeholder: "By Event",
        name: "Event"
      },
      {
        id: "carrier",
        type:"multiselect",
        options: getCarriers().map((carrier) => {return {
          id: carrier, 
          label: carrier
        }}),
        outerClassName: "sg-super-filter-select-field-option-spacing",
        placeholder: "By Carrier",
        name: "Carrier"
      },
      {
        id: "archived_at",
        type:"multiselect",
        options: [
          {
            id: "false", 
            label: "Active"
          },
          {
            id: "true", 
            label: "Archived"
          }
        ],
        outerClassName: "sg-super-filter-select-field-option-spacing",
        placeholder: "By Status",
        name: "Status"
      },
      // {
      //   id: "archived",
      //   type: "multiselect",
      //   label: "Show Archived",
      //   options: [
      //     // {
      //     //   label: "Show Archived",
      //     //   value: "true"
      //     // },
      //     // {
      //     //   label: "Show Active",
      //     //   value: "false"
      //     // }
      //   ]
      // },

      {
        id: "search",
        type:"search",
        options: [],
        outerClassName: "sg-super-filter-search-field-option-spacing",
        placeholder: "Search",
        name: "Search"
      }
      
    ].filter(x=> !x.to_filter)
  }
  
  fetchMoreData = () => {
    if(superFilters == null) {
      return;
    }
    // a fake async api call like which sends
    // 20 more records in 1.5 secs
    const currentPage = page + 1
    fetchAPI(`/webapi/receiving_items/table?page=${currentPage}`, (json)=> {
      if (!json.errors) {
        setReceivingItems(
          receivingItems.concat(json.receiving_items)
        );
        setTotalPages(json.total_pages);
        setPage(currentPage);
      } else {
        console.log({
          errors: json.errors
        })
      }
    }, {
      method: "POST",
      body: {
        superFilters: superFilters,
        sortBy: sortBy,
        sortDirection: sortDirection
      }
    });
  };
  

  const style = {
    height: 30,
    border: "1px solid green",
    margin: 6,
    padding: 8
  };

  const toolTipStyle = {
    "textAlign": "left",
    "backgroundColor": "white",
    "color": "#666666",
  }

  const showingArchived = () => {
    const filter = superFilters.find(x=>x.filterID=="archived_at")
    return filter && (filter.filterValue||[]).find(x=>x == "true")
  }

  const renderRow = (item, index) => {
    if(!showingArchived() && item.archived_at) {
      return <tr style={{height: 0}}></tr>
    }
    return (
      <tr key={`sg-receiving-item-${item.id}`}>
        <td>
          {renderItem(item.item||{})}
        </td>
        <td>
          <Tooltip
            id={`sg-ordered-tooltip-${item.id}`}
            place="bottom" 
            style={toolTipStyle}
            border="2px solid #3070E7"
            content={(
              <div>
                Ordered:
                <br/>
                {item.user ? `${item.user.first_name} ${item.user.last_name}`:""}
                <br/>
                {new Date(item.created_at).toLocaleString(
                      [], 
                      {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute:'2-digit'}
                )}
              </div>
            )}
          />
          <a href="javascript:void(0);" data-tip="true" data-tooltip-id={`sg-ordered-tooltip-${item.id}`} >
            {item.ordered || 0}
          </a>
        </td>
        <td>
          {renderReceiviedAmounts(item)}
        </td>
        <td>
          {renderTrackingNumber(item)}
        </td>
        <td>
          {renderTrackingCarrier(item)}
        </td>
        <td>
          {(item.notes||"").split("\n").map((note, index) => <div key={index}>{note}</div>)}
        </td>
        <td>
          {renderTrackingStatus(item)}
        </td>
        <td>{
          item && item.item && item.item.renter ? (
            <a href={`/inventory/${item.item.renter.id}`} >{item.item.renter.name}</a>
          ):""
        }</td>
        <td>{
          item.event ? (
            <a href={`/events/${item.event.slug}`} >{item.event.name}</a>
          ):""
        }</td>
        {renderActions(item)}

      </tr>
    )
  }
  const renderActions = (item) => {
      return (
        <td>
          <div className="sg-receiving-list-actions">
            <div className="sg-receiving-list-actions-left">
              {isJaguar(user) && (
                <button onClick={()=>setReceivingReceivingItemId(item.id)} className="sg-receiving-list-button sg-receiving-list-button-receive ">
                  Receive
                </button>
              )}
          
              
              <button onClick={()=>setEditingReceivingItemId(item.id)} className="sg-receiving-list-button sg-receiving-list-button-edit">
                Edit
              </button>
              {isJaguar(user) && (
                <button onClick={()=>attemptToggleArchive(item)} className="sg-receiving-list-button sg-receiving-list-button-delete">
                  {item.archived_at ? "Unarchive" : "Archive"}
                </button>
              )}
            </div>
          </div>
        </td>
      )

  }

  const attemptToggleArchive = async (item) => {
    const newArchivedAt = item.archived_at ? null : new Date()

    const { confirmed, reason } = await confirm({
      description: "Are you sure you want to archive this order?",
      confirmationText: "Yes",
      cancellationText: "No"
    })

    if(confirmed) {
      fetchAPI(`/webapi/receiving_items/${item.id}`, (json)=> {
        item.archived_at = newArchivedAt
        setReceivingItems(
          receivingItems.filter((receivingItem) => receivingItem.id !== item.id).concat([item])
        )
      },{
        method: "PATCH",
        body: {
          archived_at: newArchivedAt
        }
      })
    }
  }

  const deleteReceivingItem = (item) => {
    fetchAPI(`/webapi/receiving_items/${item.id}`, (json)=> {
      setReceivingItems(
        receivingItems.filter((receivingItem) => receivingItem.id !== item.id)
      )
      closeEditingRecieivingItemModal()

    },{
      method: "DELETE"
    })
  }

  const renderReceivedLogsTooltip = (key, logs) => {
    return (
      <span>
        <Tooltip
          id={`sg-received-tooltip-${key}`}
          place="bottom" 
          style={toolTipStyle}
          border="2px solid #3070E7"
          content={

            logs.length > 0 ? logs.map(log=>{
              const user = log.user
              return (
                <div style={{marginBottom: "5px"}}>
                  Received: {log.count}
                
                  {user ? (<>
                    <br/>
                    {user.first_name} {user.last_name}
                  </>):""}
                  <br/>
                  {new Date(log.created_at).toLocaleString(
                        [], 
                        {year: 'numeric', month: 'numeric', day: 'numeric', hour: '2-digit', minute:'2-digit'}
                  )}
                </div>
              )
            }) : "No Items Received Yet"
          }
        />
      </span>
    )
  }

  const renderReceiviedAmounts = (item) => {
    let trackedLogsIds = []
    const renderedByTrackingNumber = getOrderedTrackingNumbers(item).map((trackingNumber) => {
      const logs = item.item_inventory_logs.filter(log =>
        log.receiving_item_tracking_number_id == trackingNumber.id
      ) 
      trackedLogsIds = trackedLogsIds.concat(logs.map(log => log.id))
      return (
        <div
          className="sg-tracking-number-div"
          data-tip="true"
          data-tooltip-id={`sg-received-tooltip-${trackingNumber.id}`}
        >
          {logs.map(x=>x.count).reduce((a, b) => a + b, 0)}
          {renderReceivedLogsTooltip(trackingNumber.id, logs)}
        </div>  
      )
    })

    const logsWithoutTrackingNumbers = item.item_inventory_logs.filter(log =>
      !trackedLogsIds.includes(log.id)
    ) 
    let totalRenderedLogs = renderedByTrackingNumber
    if(logsWithoutTrackingNumbers.length > 0){
      totalRenderedLogs = totalRenderedLogs.concat(
        <div
          className="sg-tracking-number-div"
          data-tip="true"
          data-tooltip-id={`sg-received-tooltip-empty#${item.id}`}
        >
          {logsWithoutTrackingNumbers.map(x=>x.count).reduce((a, b) => a + b, 0)}
          {renderReceivedLogsTooltip(`empty#${item.id}`, logsWithoutTrackingNumbers)}
        </div>  
      )
    }
    return totalRenderedLogs
  }

  const getTrackingInfo = (trackingNumber) => {
    if(trackingNumber.courier) {
      const trackingCompanyMapping = {
        "ups": ups,
        "fedex": fedex,
        "usps": usps,
        "dhl": dhl,
        "ontrac": ontrac,
      }
      const normalizedCourier = (trackingNumber.courier||"").toLowerCase().replaceAll("-", "").replaceAll(" ", "")
      const currentCourierObject = trackingCompanyMapping[normalizedCourier]
      if(currentCourierObject) {
        return getTracking(trackingNumber.tracking_number, [currentCourierObject])
      }
    }
    return getTracking(trackingNumber.tracking_number)
  }

  const renderTrackingNumber = (item) => {
    return getOrderedTrackingNumbers(item).map((trackingNumber) => {
      const trackingInfo = getTrackingInfo(trackingNumber)
      const overrideTrackingUrl = trackingNumber.override_tracking_url
      let url = ""
      if(overrideTrackingUrl && overrideTrackingUrl.length > 0) {
        url = overrideTrackingUrl
      }else {
        url = trackingInfo && trackingInfo.trackingUrl ? trackingInfo.trackingUrl.replace("%s", trackingNumber.tracking_number) : ""
      }
      
      return (
        <div className="sg-tracking-number-div">
          {url ? (
            <a href={url} target="_blank">
              {trackingNumber.tracking_number}
            </a>
          ):(
            trackingNumber.tracking_number
          )}
    
        </div>  
      )
    })
  }

  const renderTrackingStatus = (item) => {
    return getOrderedTrackingNumbers(item).map((trackingNumber) => {
      const response = trackingNumber.tracking_response

      return (
        <div className="sg-tracking-number-div sg-receiving-list-tracking-status">
          {response.tracking_status && response ? response.tracking_status.status: response.status || "Unavailable"}
          <br/>
          <span>
            {response.tracking_status && response && response.tracking_status.substatus ? (
              (response.tracking_status.substatus||{}).text
            ) :""}
          </span>
        </div>  
      )
    })
  }

  const renderTrackingCarrier = (item) => {
    return getOrderedTrackingNumbers(item).map((trackingNumber) => {
      const trackingInfo = getTracking(trackingNumber.tracking_number)
      return (
        <div className="sg-tracking-number-div">
          {trackingNumber.courier ? trackingNumber.courier : (
            trackingInfo ? trackingInfo.courier.name : "Unavailable"
          )}
        </div>  
      )
    })
  }

  const getOrderedTrackingNumbers = (item) => {
    return item.receiving_item_tracking_numbers.sort((a, b) => a.id - b.id)
  }


  const renderItem = (item) => {
    return (
      <div className="sg-receiving-list-item">

        <div className="float-left">
          <ItemImageGalleryModal
            button={(
              <div>
                <img className="w-[72px] h-[72px] object-cover" src={(item.active_image||{}).image} />
                <br/>
                {item.active_image ? (
                  <button type="button" className="link-button text-[#3070E7] text-[9px] font-bold font-italic italic" onclick="return false;">
                    View Larger
                  </button>
                ):""}
              </div>
            )}
            currentImage={item.active_image}
            images={item.item_images}
          />
   
        </div>
        <div className="inline-block pl-4">
          <a href={`/items/${item.id}`} target="_blank">{item.name||"[Unnamed Item]"}</a>
          <div className="pt-2"/>
          Category:
          {item.category ? item.category.group_name||"Other" : "Other"}
          <br/>
          Subcategory:
          {item.category ? item.category.name||"Other" : "Other"}
        </div>
      </div>
    )
  }


  const getColumns = () => {
    return [
      {name: "name", label: "Item", sorting: true},
      {name: "ordered", label: "Ordered", sorting: true},
      {name: "received", label: "Received",},
      {name: "tracking", label: "Tracking"},
      {name: "carrier", label: "Carrier"},
      {name: "notes", label: "Notes"},
      {name: "status", label: "Status"},
      {name: "renter", label: "Owner", sorting: true},
      {name: "event", label: "Event", sorting: true},
      {name: "actions", label: "Actions",hidden: !isJaguar(user)},
    ].filter(column => !column.hidden)
  }

  const renderHeaderRow = () => {
    return getColumns().map((column) => {
      return (
        <ReceivingListTableHeader
          key={`receiving-list-header`-column.name}
          column={column}
          sortHeaderClicked={sortHeaderClicked}
          sortBy={sortBy}
          sortDirection={sortDirection}
        />
      )
    }) 
  }


  const renderSortingIcon = (column) => {
    return (
      <div
        style={{
          display: "inline-block",
          marginLeft: "5px",
          marginTop: "2px",
          float: "right"
        }}
      >
        {sortBy == column ? <ArrowUpwardIcon style={{transform: `rotate(${sortDirection == "asc" ? 0 : 180}deg)`}}/> : <SortIcon />}
      </div>
    )
  }

  const sortHeaderClicked = (column) => {
    setReceivingItems([])
    setPage(0)
    if(column == sortBy) {
      if(sortDirection == "asc") {
        setSortBy(column)
        setSortDirection("desc")
      }else {
        setSortDirection("asc")
        setSortBy(null)
      }
    }else {
      setSortBy(column)
      setSortDirection("asc")
    }
  }


  const [editingReceivingItemId, setEditingReceivingItemId] = useState(null)
  const [receivingReceivingItemId, setReceivingReceivingItemId] = useState(null)

  const closeEditingRecieivingItemModal = () => {
    setEditingReceivingItemId(null)
    setReceivingReceivingItemId(null)
    refreshSingleReceivingItem(
      editingReceivingItemId||receivingReceivingItemId
    )
  }

  refreshSingleReceivingItem = (receivingItemId) => {
    const index = receivingItems.findIndex((receivingItem) => receivingItem.id === receivingItemId)
    fetchAPI(`/webapi/receiving_items/${receivingItemId}`, (json)=> {
      const newReceivingItems = receivingItems
      if(json.receiving_item) {
        newReceivingItems[index] = json.receiving_item
        setReceivingItems(newReceivingItems.concat([]))
      }else {
        newReceivingItems.splice(index, 1)
        setReceivingItems(newReceivingItems.concat([]))
      }

    }, {});
  }

  
  const [ createNewItemModalOpen, setCreateNewItemModalOpen ] = useState(false)


  return (
    <>  
        <ReceivingListModal
          user={user}
          open={editingReceivingItemId !== null}
          receivingItemId={editingReceivingItemId}
          closeModal={ closeEditingRecieivingItemModal}
            deleteItem={deleteReceivingItem}
        />
        <ReceivingListRecieveModal
          open={receivingReceivingItemId !== null}
          receivingItemId={receivingReceivingItemId}
          closeModal={ closeEditingRecieivingItemModal}
          deleteItem={deleteReceivingItem}
        />
        {isJaguar(user) ? (
          <CreateNewItemSearchModal 
            open={createNewItemModalOpen}
            onClose={(json) => {
              if(json && json.id) {
                setReceivingItems([])
                setPage(0)
                setTimeout(() => {
                  fetchMoreData()
                }, 1000)

              }
              setCreateNewItemModalOpen(false)
            }}
            user={user}
            loadItems={true}
            events={events}
            renter={{
              id: 'all'
            }}
            useAddInventory={true}
          />)
        :""}
        {isJaguar(user) ? (
          <Button
            variant="contained"
            color="primary"
            size="large"
            className="float-right pull-right"
            onClick={() => setCreateNewItemModalOpen(true)}
          >Add To Receiving List</Button>
        ):""}
        <div>
        {renderSuperFilter()}
        </div>
        <InfiniteScroll
          dataLength={receivingItems.length}
          next={fetchMoreData}
          hasMore={page < total_pages}

          refreshFunction={fetchMoreData}
          loader={<h4>Loading...</h4>}
        >
          <table className="min-w-full sg-receiving-list-table">
          {renderHeaderRow()}
          {receivingItems.map((i, index) => (
            renderRow(i, index)
          ))}
          </table>
        </InfiniteScroll>
    </>
  )
}


const ReceivingListTableHeader = ({
  column,
  sortBy,
  sortDirection,
  sortHeaderClicked
}) => {
  const { name, label, sorting } = column
  
  const headerRef = useRef(null);
  const [ width, setWidth ] = useState("auto")

  const resizeRow = ({  deltaX }) => {
    let newWidth = width
    if(newWidth == "auto") {
      newWidth = headerRef.current.offsetWidth
    }
    newWidth += deltaX
    setWidth(newWidth)
  }

  const renderSortingIcon = () => {

    return (
      <div
        style={{
          display: "inline-block",
          marginLeft: "5px",
          marginTop: "2px",
          marginRight: "5px",
          position: "absolute",
          right: "10px"
        }}
      >
        {sortBy == name ? <ArrowUpwardIcon style={{transform: `rotate(${sortDirection == "asc" ? 0 : 180}deg)`}}/> : <SortIcon />}
      </div>
    )
  }
  return (
    <th
      ref={headerRef}
      style={{
        position: "relative",
        cursor: column.sorting == false ? "default" : "pointer",
        width: width == "auto" ? "auto" : `${width}px`,
        whiteSpace: "nowrap",
        paddingRight: "30px",
        textOverflow: "ellipsis",
        overflow: "hidden"
      }}
      onClick={()=>sortHeaderClicked(name)}
    >
      {label}
      {sorting ? renderSortingIcon() : ""}
      {column.resizable != false ? (
        <Draggable
          axis="x"
          defaultClassName="DragHandle"
          defaultClassNameDragging="DragHandleActive"
          onDrag={(event, { deltaX }) =>{
            event.preventDefault()
            event.stopPropagation()
            resizeRow({
              deltaX
            })
          }}
          position={{ x: 0 }}
          zIndex={999}
        >
          <span className="DragHandleIcon absolute right-0 px-2">⋮</span>
        </Draggable>
      ):""}
    </th>
  )
}

export default ReceivingListTable;
